import type { ReactNode } from 'react'

interface GlassCardProps {
  children: ReactNode
  className?: string
  hover?: boolean
  onClick?: () => void
}

export default function GlassCard({ children, className = '', hover = false, onClick }: GlassCardProps) {
  return (
    <div
      onClick={onClick}
      className={`glass rounded-xl p-5 ${hover ? 'glass-hover cursor-pointer' : ''} ${className}`}
    >
      {children}
    </div>
  )
}
